import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=10ad17b3&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=10ad17b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad17b3",
  null
  
)

export default component.exports